import React from "react";
import PropTypes from "prop-types";
import cx from "clsx";
import classes from "./SelectNative.module.scss";

const SIZES = {
  small: "small",
};

export function SelectNative({
  options,
  className,
  name,
  onChange,
  value,
  isError,
  isDisabled,
  size,
}) {
  const rootClasses = cx(
    classes.root,
    {
      [classes.error]: isError,
      [classes.disabled]: isDisabled,
      [classes.sSmall]: size === SIZES.small,
    },
    className,
  );

  return (
    <select
      className={rootClasses}
      name={name}
      onChange={onChange}
      value={value}
    >
      {options.map((option, index) => (
        <option
          key={`${index}-${option.value}`}
          disabled={option.isDisabled}
          value={option.value}
        >
          {option.label}
        </option>
      ))}
    </select>
  );
}

SelectNative.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      isDisabled: PropTypes.bool,
    }),
  ),
  className: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isError: PropTypes.bool,
  isDisabled: PropTypes.bool,
  size: PropTypes.oneOf(Object.values(SIZES)),
};

SelectNative.defaultProps = {
  options: [],
  className: undefined,
  name: undefined,
  onChange: () => {},
  value: undefined,
  isError: false,
  isDisabled: false,
  size: undefined,
};
